module.exports = __webpack_public_path__ + "img/092-cloud-6.c5a00088.svg";